(function () {
  var AUTO_CLOSE_MS = 10000;
  var AUTO_CLOSE_REDUCED_MS = 20000;

  function getAutoCloseDelay() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches
      ? AUTO_CLOSE_REDUCED_MS
      : AUTO_CLOSE_MS;
  }

  function syncFaqA11y(scope) {
    if (!scope?.querySelectorAll) return;

    scope.querySelectorAll('.canicule-faq__item').forEach((item) => {
      const summary = item.querySelector('summary.canicule-faq__question');
      if (!summary || summary.dataset.faqA11yBound === 'true') return;

      summary.dataset.faqA11yBound = 'true';

      const sync = () => {
        summary.setAttribute('aria-expanded', item.open ? 'true' : 'false');
      };

      sync();
      item.addEventListener('toggle', () => {
        sync();
        if (item.open) {
          if (item._autoCloseTimer) clearTimeout(item._autoCloseTimer);
          item._autoCloseTimer = setTimeout(() => {
            if (item.open) item.open = false;
          }, getAutoCloseDelay());
        } else if (item._autoCloseTimer) {
          clearTimeout(item._autoCloseTimer);
          item._autoCloseTimer = null;
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => syncFaqA11y(document));
  document.addEventListener('shopify:section:load', (event) => syncFaqA11y(event.target));
})();
